import moment from 'moment';

export const getTimeAgo = (timestamp) => {
  const updatedAt = moment(timestamp);
  const now = moment();

  const duration = moment.duration(now.diff(updatedAt));

  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) return 'Just now';

  const parts = [];
  if (days > 0) parts.push(`${days} day${days > 1 ? 's' : ''}`);
  if (hours > 0) parts.push(`${hours} hr${hours > 1 ? 's' : ''}`);
  if (minutes > 0) parts.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
  if (seconds > 0) parts.push(`${seconds} sec${seconds > 1 ? 's' : ''}`);

  return `${parts.join(' ')} ago`;
};
